import { defineStore } from 'pinia'
import { ref, computed, Ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getDoctor, updateDoctor } from '@services/doctor.service'
import { type Doctor } from '@m/cabinet/modules/Doctor/types'

const id = 'doctorStore'

export const useDoctorStore = defineStore(id, () => {
  const loading: Ref<boolean> = ref(false)
  const doctor = ref({})

  const route = useRoute()
  const router = useRouter()

  function setLoading(value: boolean): void {
    loading.value = value
  }

  function setDoctor(newDoctor: Doctor): void {
    doctor.value = newDoctor
  }

  async function receive(id: string): Promise<void> {
    setLoading(true)

    return await getDoctor.execute({ id })
      .then(({ item }) => {
        setDoctor(item)
      })
      .catch((error: Response) => {
        router.push({
          name: 'cabinet:not-found',
          // Match the path of your current page and keep the same url...
          params: { pathMatch: route.path.split('/').slice(1).slice(0, -1) },
          // ...and the same query and hash.
          query: route.query,
          hash: route.hash,
        })
        setDoctor(null)
        console.warn(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  function patch(id, payload: Record<string, any>) {
    return updateDoctor.execute({ id }, payload)
      .then(({ item }) => {
        setDoctor(item)
        return item
      })
  }

  return {
    loading,
    doctor,
    setDoctor,
    setLoading,
    receive,
    patch,
  }
})
